// extracted by mini-css-extract-plugin
export default {"footerContent":"footerContent---bmMTw"};